import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      fragment IndividualProduct on ProductVariant {\n        id\n        name\n        productIdLightLoad\n        productNameLightLoad\n        categoryNameLightLoad\n        categoryIdLightLoad\n        hasAttributeLightLoad\n        productDefaultImageIdLightLoad\n        productImagesLightLoad {\n          id\n          alt\n          url\n        }\n        priceLightLoad {\n          amount\n          currency\n        }\n        saleProductsLightLoad {\n          name\n          type\n          value\n        }\n        saleSubCategoryLightLoad {\n          name\n          type\n          value\n        }\n        saleCategoryLightLoad {\n          name\n          type\n          value\n        }\n      }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import "./scss/index.scss";
import React, { useContext, useState } from "react";
import { ApolloContext } from "react-apollo";
import gql from "graphql-tag";
import { useCart, useProductDescriptionAndAttributes } from "@saleor/sdk";
import { useProductData } from "@temp/hooks";
import { useParams } from "react-router-dom";
import Page from "./Page";
import { MetaWrapper, NotFound, MainMenu, Loader, AlertCheckoutErrors } from "../../components";
import { getGraphqlIdFromDBId } from "../../core/utils";

var PageWithQueryAttributes = function PageWithQueryAttributes(props) {
  return React.createElement(Page, props);
};

var View = function View() {
  var _useParams = useParams(),
      id = _useParams.id,
      lineId = _useParams.lineId;

  var _useCart = useCart(),
      addItem = _useCart.addItem,
      items = _useCart.items,
      removeItem = _useCart.removeItem,
      updateItem = _useCart.updateItem;

  var _useContext = useContext(ApolloContext),
      ApolloClient = _useContext.client;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      errors = _useState4[0],
      setErrors = _useState4[1];

  var productVariantId = getGraphqlIdFromDBId(id, "ProductVariant");

  var _useProductDescriptio = useProductDescriptionAndAttributes({
    id: id
  }, {
    fetchPolicy: "network-only"
  }),
      dataNetwork = _useProductDescriptio.data,
      loadingNetwork = _useProductDescriptio.loading;

  var productVariantActual = ApolloClient.readFragment({
    id: "ProductVariant:".concat(productVariantId),
    fragment: gql(_templateObject()),
    fragmentName: "IndividualProduct"
  });

  if (!(productVariantActual === null || productVariantActual === void 0 ? void 0 : productVariantActual.id)) {
    return React.createElement(NotFound, null);
  }

  var _useProductData = useProductData(productVariantId, items, productVariantActual, lineId),
      productFinalData = _useProductData.productFinalData;

  var handleAddItem = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(variantId, quantity, observation, attributes) {
      var _yield$addItem, dataError;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.next = 3;
              return addItem(variantId, quantity, observation, attributes);

            case 3:
              _yield$addItem = _context.sent;
              dataError = _yield$addItem.dataError;

              if (!dataError) {
                _context.next = 9;
                break;
              }

              setErrors(dataError);
              setLoading(false);
              return _context.abrupt("return", false);

            case 9:
              setLoading(false);
              return _context.abrupt("return", true);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleAddItem(_x, _x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleUpdateItem = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(variantId, quantity, observation) {
      var _yield$updateItem, dataError;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              _context2.next = 3;
              return updateItem(variantId, quantity, observation);

            case 3:
              _yield$updateItem = _context2.sent;
              dataError = _yield$updateItem.dataError;

              if (!dataError) {
                _context2.next = 9;
                break;
              }

              setErrors(dataError);
              setLoading(false);
              return _context2.abrupt("return", false);

            case 9:
              setLoading(false);
              return _context2.abrupt("return", true);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleUpdateItem(_x5, _x6, _x7) {
      return _ref2.apply(this, arguments);
    };
  }();

  return React.createElement(React.Fragment, null, React.createElement(MainMenu, {
    gobackProduct: true,
    search: false,
    cart: true
  }), !!(productFinalData === null || productFinalData === void 0 ? void 0 : productFinalData.name) && !!(productFinalData === null || productFinalData === void 0 ? void 0 : productFinalData.price) ? React.createElement(MetaWrapper, {
    meta: {
      title: productFinalData === null || productFinalData === void 0 ? void 0 : productFinalData.name
    }
  }, React.createElement("div", {
    className: "categories-page"
  }, React.createElement(PageWithQueryAttributes, {
    dataNetwork: dataNetwork === null || dataNetwork === void 0 ? void 0 : dataNetwork.productDescriptionAndAttributesLightLoad,
    loadingNetwork: loadingNetwork,
    product: productFinalData,
    add: handleAddItem,
    items: items,
    updateItem: handleUpdateItem,
    removeItem: removeItem,
    lineId: lineId
  }))) : React.createElement(NotFound, null), loading && React.createElement("div", {
    className: "productVariantViewNetwork__loader"
  }, React.createElement(Loader, null)), (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && React.createElement(AlertCheckoutErrors, {
    fromProduct: true,
    fromProductEdit: !!lineId,
    hideModal: function hideModal() {
      setErrors([]);
    },
    errors: errors
  }));
};

export default View;